<div class="header-fixed menubar-pin parent-container">
  <div id="base">
    <div id="content" class="fees-overdue-main-container">

      <!-- Page Heading and Export -->
      <div class="page-name-heading-with-export-button">
        <div class="page-name-attendance">
          <div class="report-text">{{'reports' | translate}}/ <span class="fees-overdue-heading">{{'feesOverdueReport' | translate}}</span></div>
        </div>
        <div>
          <button *ngIf="((overdueFeeData && overdueFeeData.length > 0) || (tableBodyData && tableBodyData.length > 0)) && !isExportingReport"
            (click)="handleExportButtonClick()"
            class="btn-export-fees-overdue-report">
            <i class="ri-download-2-line"></i>
            {{'export' | translate}}
          </button>

          <button
            *ngIf="((overdueFeeData && overdueFeeData.length > 0) || (tableBodyData && tableBodyData.length > 0)) && isExportingReport"
            class="btn-export-fees-overdue-report" disabled>
            <app-button-loader></app-button-loader>
          </button>
        </div>
      </div>

      <!-- Filters -->
      <div class="filter-container-attendance" [ngClass]="{
        'filter-container-attendance': !isFilterExpanded && appliedWings.length !== 1 && appliedClasses.length !== 1 && appliedSections.length !== 1,
        'filter-container-attendance-open': isFilterExpanded && !(appliedWings.length === 1 && appliedClasses.length === 1 && appliedSections.length === 1) && !(selectedWings.length === 1 && selectedClasses.length === 1 && selectedSections.length === 1),
        'filter-container-attendance-open-and-closed': isFilterExpanded && appliedWings.length === 1 && appliedClasses.length === 1 && appliedSections.length === 1 && !(selectedWings.length === 1 && selectedClasses.length === 1 && selectedSections.length === 1),
        'single-selection-active': appliedWings.length === 1 && appliedClasses.length === 1 && appliedSections.length === 1 && !isFilterExpanded,
        'single-selection-active-open': selectedWings.length === 1 && selectedClasses.length === 1 && selectedSections.length === 1 && isFilterExpanded && !(appliedWings.length === 1 && appliedClasses.length === 1 && appliedSections.length === 1),
        'single-selection-active-open-and-closed': selectedWings.length === 1 && selectedClasses.length === 1 && selectedSections.length === 1 && isFilterExpanded && appliedWings.length === 1 && appliedClasses.length === 1 && appliedSections.length === 1,

      }">
        <div class="filter-data-attendance">
          <div class="filters-names-attendance">
            <div class="filter-text">{{ 'filter' | translate }} :</div>
            <div class="applied-filters">
              <span class="filter-name-text">{{ 'wing' | translate }} : </span>
              <span> {{ appliedWingsLabel }}</span>
            </div>
            <div class="applied-filters">
              <span class="filter-name-text">{{ 'class' | translate }} : </span>
              <span> {{ appliedClassesLabel }}</span>
            </div>
            <div class="applied-filters">
              <span class="filter-name-text">{{ 'section' | translate }} : </span>
              <span>{{ appliedSectionsLabel }}</span>
            </div>
            <div class="applied-filters"
              *ngIf="appliedWings.length === 1 && appliedClasses.length === 1 && appliedSections.length === 1">
              <span class="filter-name-text">{{ 'selectedStudent' | translate }} : </span>
              <span>{{ appliedStudentLabel }}</span>
            </div>
            <div class="applied-filters"
              *ngIf="appliedWings.length === 1 && appliedClasses.length === 1 && appliedSections.length === 1">
              <span class="filter-name-text">{{'sortBy' | translate}} : </span>
              <span>{{ appliedSortLabel }}</span>
            </div>
            <div class="applied-filters">
              <span class="filter-name-text">{{'fee' | translate}} : </span>
              <span>{{ appliedFeeLabel }}</span>
            </div>
            <div class="applied-filters">
              <span class="filter-name-text">{{'status' | translate}} : </span>
              <span> {{ appliedStatusLabel }}</span>
            </div>
          </div>
          <div class="apply-and-reset-filter">
            <div *ngIf="enableReset || enableBackButton" (click)="resetAllFilter()" class="reset-button">
                            {{ enableBackButton ? ('back' | translate) : ('reset' | translate)}}
            </div>
            
            <div *ngIf="!isFilterExpanded" class="more-filter-button">
              <button (click)="expandAllFilterItems()">{{ 'moreFilter'|translate }}</button>
            </div>
            <div *ngIf="isFilterExpanded" class="less-filter-button">
              <button (click)="expandAllFilterItems()">{{ 'lessFilter' | translate }}</button>
            </div>
          </div>
        </div>

        <div [ngClass]="{
          'selection-option': !isFilterExpanded,
          'selection-option-active': isFilterExpanded
        }">
          <div class=" main-container-selection">
            <label class="select-box-label">{{ 'selectWing' | translate  }}</label>
            <div class="input-for-selection-expense">
              <p-multiSelect [options]="wingListData" [(ngModel)]="selectedWings" optionLabel="classCategoryName"
                display="comma" [maxSelectedLabels]="1" [selectedItemsLabel]="wingSelectedItemsLabel" placeholder="None"
                (onChange)="onWingChange()" [loading]="loadingWingData" />
            </div>
          </div>
          <div class="main-container-selection">
            <label class="select-box-label">{{ 'selectClass' | translate  }}</label>
            <div class="input-for-selection-expense">
              <p-multiSelect [options]="classStandardData" [(ngModel)]="selectedClasses" optionLabel="classStandardName"
                display="comma" [maxSelectedLabels]="1" [selectedItemsLabel]="classSelectedItemsLabel"
                placeholder="None" (onChange)="onClassChange()" [loading]="loadingClassData"
                [disabled]="selectedWings.length < 1" />
            </div>
          </div>
          <div class="main-container-selection">
            <label class="select-box-label">{{ 'selectSection' | translate  }}</label>
            <div class="input-for-selection-expense">
              <p-multiSelect [options]="classSectionData" [(ngModel)]="selectedSections" optionLabel="displayLabel"
                display="comma" [maxSelectedLabels]="1" [selectedItemsLabel]="sectionSelectedItemsLabel"
                placeholder="None" (onChange)="onSectionChange()" [loading]="loadingSectionData"
                [disabled]="selectedClasses.length < 1" />
            </div>
          </div>
          <div class="main-container-selection"
            *ngIf="selectedSections.length === 1 && selectedClasses.length === 1 && selectedWings.length === 1">
            <label class="select-box-label">{{ 'selectStudent' | translate }}</label>
            <div class="input-for-selection-expense">
              <p-multiSelect [options]="studentList" [(ngModel)]="selectedStudents" optionLabel="studentName"
                display="comma" [maxSelectedLabels]="1" [selectedItemsLabel]="studentSelectedItemsLabel"
                placeholder="None" (onChange)="onStudentChange()" [loading]="loadingStudentData" />
            </div>
          </div>

          <div class="main-container-selection" #sortDropdownContainer
            *ngIf="selectedSections.length === 1 && selectedClasses.length === 1 && selectedWings.length === 1">
            <label class="select-box-label">{{ 'sortBy' | translate }}</label>
            <div class="input-for-selection-expense position-relative">
              <div class="p-multiselect p-component dropdown-trigger" (click)="toggleSortDropdown()">
                <div class="p-multiselect-label-container">
                  <div class="p-multiselect-label">
                    {{ getSelectedSortLabel() }}
                  </div>
                </div>
                <div class="p-multiselect-trigger">
                  <span class="p-multiselect-trigger-icon pi pi-chevron-down"></span>
                </div>
              </div>

              <div class="custom-fee-dropdown-panel custom-dropdown-panel" *ngIf="isSortDropdownOpen">
                <div class="fee-dropdown-body">
                  <!-- Student Id -->
                  <div class="fee-group">
                    <div class="fee-group-header">
                      <span class="fee-label"
                        (click)="toggleSortCategory('studentId')">{{sortSelectionData.studentId.label}}</span>
                      <i class="fa toggle-icon"
                        [ngClass]="sortSelectionData.studentId.isExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                        (click)="toggleSortCategory('studentId')"></i>
                    </div>
                    <div class="fee-group-body" *ngIf="sortSelectionData.studentId.isExpanded">
                      <div class="fee-item" *ngFor="let opt of sortSelectionData.studentId.options; let i = index">
                        <p-checkbox binary="true" [(ngModel)]="opt.isSelected"
                          (onChange)="onSortOptionChange('studentId', i)"></p-checkbox>
                        <span>{{opt.label}}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Roll Number -->
                  <div class="fee-group">
                    <div class="fee-group-header">
                      <span class="fee-label"
                        (click)="toggleSortCategory('rollNumber')">{{sortSelectionData.rollNumber.label}}</span>
                      <i class="fa toggle-icon"
                        [ngClass]="sortSelectionData.rollNumber.isExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                        (click)="toggleSortCategory('rollNumber')"></i>
                    </div>
                    <div class="fee-group-body" *ngIf="sortSelectionData.rollNumber.isExpanded">
                      <div class="fee-item" *ngFor="let opt of sortSelectionData.rollNumber.options; let i = index">
                        <p-checkbox binary="true" [(ngModel)]="opt.isSelected"
                          (onChange)="onSortOptionChange('rollNumber', i)"></p-checkbox>
                        <span>{{opt.label}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="main-container-selection" #feeDropdownContainer>
            <label class="select-box-label">{{'selectFeeType' | translate}}</label>
            <div class="input-for-selection-expense position-relative">
              <div class="p-multiselect p-component dropdown-trigger" (click)="toggleFeeDropdown()">
                <div class="p-multiselect-label-container">
                  <div class="p-multiselect-label">
                    {{ getSelectedFeesCount() === 0 ? 'None' : (getSelectedFeesCount() === getTotalFeesCount() ? 'All' :
                    getSelectedFeesCount() + ' ' + ('selected' | translate)) }}
                  </div>
                </div>
                <div class="p-multiselect-trigger">
                  <span class="p-multiselect-trigger-icon"
                    [ngClass]="loadingFeeListData ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'"></span>
                </div>
              </div>
              <div class="custom-fee-dropdown-panel custom-dropdown-panel" *ngIf="isFeeDropdownOpen">
                <div class="fee-dropdown-header">

                  <div class="fee-info-container fee-info-wider">
                    <i class="pi pi-info-circle fee-info-icon"></i>
                    <span>{{'disabledFeesMsg' | translate }}</span>
                  </div>

                  <div class="fee-header-actions">
                    <div class="fee-select-all" (click)="$event.stopPropagation()">
                      <p-checkbox binary="true" [(ngModel)]="allFeesSelected"
                        (onChange)="toggleSelectAllFees()"></p-checkbox>
                    </div>
                    <div class="fee-search-container">
                      <input type="text" class="fee-search-input" placeholder="{{ 'searchFees' | translate }}..."
                        [(ngModel)]="feeSearchText" (click)="$event.stopPropagation()" #feeSearchInput />
                      <i class="pi pi-search fee-search-icon"></i>
                      <i class="pi pi-times fee-search-clear" *ngIf="feeSearchText" (click)="clearFeeSearch()"></i>
                    </div>

                    <i class="pi pi-times fee-close-button" (click)="closeFeeDropdown()"></i>
                  </div>
                </div>
                <div class="fee-dropdown-body">
                  <div class="fee-group" *ngIf="shouldShowFeeGroup('termFees')">
                    <div class="fee-group-header" (click)="$event.stopPropagation()">
                      <p-checkbox binary="true" [(ngModel)]="feeSelectionData.termFees.isSelected"
                        (onChange)="onTermFeesChange()"></p-checkbox>
                      <span class="fee-label"
                        (click)="toggleFeeCategory('termFees'); $event.stopPropagation()">{{feeSelectionData.termFees.label}}</span>
                      <i class="fa toggle-icon" [ngClass]="feeSelectionData.termFees.isExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                        (click)="toggleFeeCategory('termFees'); $event.stopPropagation()"></i>
                    </div>
                    <div class="fee-group-body" *ngIf="feeSelectionData.termFees.isExpanded">
                      <ng-container *ngFor="let term of feeSelectionData.termFees.feesTypes; let i = index">
                        <div *ngIf="shouldShowFeeChild('termFees', i)">
                          <div class="fee-sub-group-header" (click)="$event.stopPropagation()">
                            <p-checkbox binary="true" [(ngModel)]="term.isSelected" [disabled]="term.isDueDatePassed !== 1"
                              (onChange)="onTermChildChange(i)"></p-checkbox>
                            <span class="fee-label" [class.disabled]="term.isDueDatePassed !== 1"
                              (click)="term.isDueDatePassed === 1 && toggleFeeSubCategory('termFees', i); $event.stopPropagation()">{{term.name}}</span>
                            <i class="fa toggle-icon" [ngClass]="term.isExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                              (click)="term.isDueDatePassed === 1 && toggleFeeSubCategory('termFees', i); $event.stopPropagation()"></i>
                          </div>
                          <div class="fee-sub-group-body" *ngIf="term.isExpanded">
                            <ng-container *ngFor="let fee of getFilteredAndSortedTermChildren(i)">
                              <div class="fee-item" style="pointer-events: none;">
                                <p-checkbox binary="true" [(ngModel)]="fee.isSelected" [disabled]="!fee.isSelectable"></p-checkbox>
                                <span>{{fee.name}}</span>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="fee-group" *ngIf="shouldShowFeeGroup('typeFees')">
                    <div class="fee-group-header" (click)="$event.stopPropagation()">
                      <p-checkbox binary="true" [(ngModel)]="feeSelectionData.typeFees.isSelected"
                        (onChange)="onTypeFeesChange()"></p-checkbox>
                      <span class="fee-label"
                        (click)="toggleFeeCategory('typeFees'); $event.stopPropagation()">{{feeSelectionData.typeFees.label}}</span>
                      <i class="fa toggle-icon" [ngClass]="feeSelectionData.typeFees.isExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                        (click)="toggleFeeCategory('typeFees'); $event.stopPropagation()"></i>
                    </div>
                    <div class="fee-group-body" *ngIf="feeSelectionData.typeFees.isExpanded">
                      <ng-container *ngFor="let fee of feeSelectionData.typeFees.feesTypes; let i = index">
                        <div class="fee-item" *ngIf="!feeSearchText || fee.name.toLowerCase().includes(feeSearchText.toLowerCase())"
                          (click)="$event.stopPropagation()">
                          <p-checkbox binary="true" [(ngModel)]="fee.isSelected" [disabled]="!fee.isSelectable"
                            (onChange)="onTypeFeeChildChange()"></p-checkbox>
                          <span [class.disabled]="!fee.isSelectable">{{fee.name}}</span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="fee-group" *ngIf="shouldShowFeeGroup('transportFees')">
                    <div class="fee-group-header" (click)="$event.stopPropagation()">
                      <p-checkbox binary="true" [(ngModel)]="feeSelectionData.transportFees.isSelected"
                        (onChange)="onTransportFeesChange()"></p-checkbox>
                      <span class="fee-label"
                        (click)="toggleFeeCategory('transportFees'); $event.stopPropagation()">{{feeSelectionData.transportFees.label}}</span>
                      <i class="fa toggle-icon"
                        [ngClass]="feeSelectionData.transportFees.isExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                        (click)="toggleFeeCategory('transportFees'); $event.stopPropagation()"></i>
                    </div>
                    <div class="fee-group-body" *ngIf="feeSelectionData.transportFees.isExpanded">
                      <ng-container *ngFor="let fee of feeSelectionData.transportFees.feesTypes; let i = index">
                        <div class="fee-item" *ngIf="!feeSearchText || fee.name.toLowerCase().includes(feeSearchText.toLowerCase())"
                          (click)="$event.stopPropagation()">
                          <p-checkbox binary="true" [(ngModel)]="fee.isSelected" [disabled]="!fee.isSelectable"
                            (onChange)="onTransportFeeChildChange()"></p-checkbox>
                          <span [class.disabled]="!fee.isSelectable">{{fee.name}}</span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <div class="fee-group" *ngIf="shouldShowFeeGroup('otherFees')">
                    <div class="fee-group-header" (click)="$event.stopPropagation()">
                      <p-checkbox binary="true" [(ngModel)]="feeSelectionData.otherFees.isSelected"
                        (onChange)="onOtherFeesChange()"></p-checkbox>
                      <span class="fee-label"
                        (click)="toggleFeeCategory('otherFees'); $event.stopPropagation()">{{feeSelectionData.otherFees.label}}</span>
                      <i class="fa toggle-icon" [ngClass]="feeSelectionData.otherFees.isExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                        (click)="toggleFeeCategory('otherFees'); $event.stopPropagation()"></i>
                    </div>
                    <div class="fee-group-body" *ngIf="feeSelectionData.otherFees.isExpanded">
                      <ng-container *ngFor="let category of feeSelectionData.otherFees.feesTypes; let i = index">
                        <div *ngIf="shouldShowFeeChild('otherFees', i)">
                          <div class="fee-sub-group-header" (click)="$event.stopPropagation()">
                            <p-checkbox binary="true" [(ngModel)]="category.isSelected"
                              (onChange)="onOtherFeeChildChange(i)"></p-checkbox>
                            <span class="fee-label" [class.disabled]="!hasSelectableChildren(category)"
                              (click)="toggleFeeSubCategory('otherFees', i); $event.stopPropagation()">{{category.name}}</span>
                            <i class="fa toggle-icon" [ngClass]="category.isExpanded ? 'fa-angle-down' : 'fa-angle-right'"
                              (click)="toggleFeeSubCategory('otherFees', i); $event.stopPropagation()"></i>
                          </div>
                          <div class="fee-sub-group-body" *ngIf="category.isExpanded">
                            <ng-container *ngFor="let fee of category.feesSubTypes; let j = index">
                              <div class="fee-item" *ngIf="shouldShowFeeItem('otherFees', i, j)" (click)="$event.stopPropagation()">
                                <p-checkbox binary="true" [(ngModel)]="fee.isSelected" [disabled]="!fee.isSelectable"
                                  (onChange)="onOtherFeeGrandchildChange(i)"></p-checkbox>
                                <span [class.disabled]="!fee.isSelectable">{{fee.name}}</span>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="main-container-selection">
            <label class="select-box-label">{{'selectStatus' | translate}}</label>
            <div class="input-for-selection-expense">
              <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus" optionLabel="label"
                placeholder="Select Status" (onChange)="onStatusChange()" [filter]="false" [showClear]="false" />
            </div>
          </div>

        </div>
        <div [ngClass]="{
    'apply-result-and-data-length': isFilterExpanded,
    'apply-result-and-data-length-disabled': !isFilterExpanded
  }">
          <div class="result-length">{{ resultAvailable }} {{'resultsAvailable' | translate}}</div>
   
          <div class="apply-filter-button">
            <button (click)="applyFilter()" [disabled]="isAnyDropdownLoading()"
              [ngClass]="{'button-loading': isAnyDropdownLoading()}">
              <span *ngIf="!isAnyDropdownLoading()">{{'applyFilter' | translate }}</span>
              <i *ngIf="isAnyDropdownLoading()" class="pi pi-spinner pi-spin"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Stats -->
      <div class="student-stats-container-main">
        <ng-container *ngIf="!loadingStatData">
          <div *ngFor="let key of studentStatData" class="total-student-count">
            <div class="heading-stat">
              {{ key.statKey }}
              <i class="fa fa-info-circle" data-toggle="tooltip" data-placement="top" [attr.title]= "key.statDescription" style="cursor: pointer; margin-left: 5px; color: var(--brand-primary-color);"></i>
            </div>
            <div class="number-of-student" [title]='generateText(key.statValue)'>
              {{schoolCurrencySymbol}}{{ formatNumber(key.statValue) }}
            </div>
          </div>
        </ng-container>

         <div *ngIf="loadingStatData" class="loader-data">
                    <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
          </div>
      </div>

      <!-- Class Tiles -->
         <div [ngClass]="{
          'class-wise-data': !loadingClassTileData,
          'class-wise-data-loading': loadingClassTileData
        }">
        <ng-container *ngIf="!loadingClassTileData">
          <div *ngFor="let key of overdueFeeData" class="class-attendance-stats" (click)="fetchSelectedClassData(key)">
            <div class="header-class-stats">
              <div class="class-name">{{ key.class }} - {{ key.section }}</div>
            </div>
            <div class="data-stats-student">
              <div class="collected-fee">
                <div class="present-icon"></div>
                <div>
                  <div class="collected-fee-label">{{'feeCollected' | translate }}</div>
                  <div class="collected-fee-value" [title]='generateText(key.feeCollected)'>{{ key.formatedFeeCollected
                    }}</div>
                </div>
              </div>
              <div class="fee-overdue">
                <div class="absent-icon"></div>
                <div>
                  <div class="collected-fee-label">{{'feesOverdue' | translate}}</div>
                  <div class="collected-fee-value" [title]='generateText(key.feeOverdue)'>{{ key.formatedFeeOverdue }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

            <div *ngIf="loadingClassTileData" class="loader-data">
                    <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                </div>
                </div>

      <!-- Table View -->

            <div class="table-of-student" *ngIf="tableHeaderData.length > 0">
              <table class="table-data-category-wise">
                <thead class="overdue-fee-report-table-header">
                  <tr>
                    <ng-container *ngFor="let itemData of tableHeaderData; let i = index">
                      <th *ngIf="itemData.isDefault === 1" (click)="openTableHeadersOption(i)">
                        <div class="table-header-th">
                          <div class="column-name">{{ itemData.columnName }}</div>
                          <div class="option-opener">
                            <img class="row-dropdown-category" src="../../assets/img/row-dropdown.png" alt="arrow" />
                          </div>
                          <ng-container>
                            <div *ngIf="optionHeaderIndex === i" class="options-in-header">
                              <ng-container *ngFor="let item of tableHeaderData">
                                <div (click)="
                                      !item.isDefault &&
                                        updateTableColumn(itemData.slug, item.slug)
                                    " class="option-value-data">
                                  <input id="input-box-{{ item.slug }}" [checked]="item.isDefault" [disabled]="item.isDefault"
                                    class="checkbox-selection-table" type="checkbox" />
                                  <label [ngClass]="{
                                        'table-extra-column': item.isDefault === 1,
                                        'table-extra-column-active':
                                          item.isDefault !== 1
                                      }" for="input-box-{{ item.slug }}">
                                    {{ item.columnName }}
                                  </label>
                                </div>
                              </ng-container>
                            </div>
                          </ng-container>
                        </div>
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody class="overdue-fee-report-table-body" (click)="closeCollapseOptionTable()">
                  <!-- Loader Row -->
                  <ng-container *ngIf="loadingClassTableData">
                    <tr>
                      <td [attr.colspan]="getDefaultColumnsCount()" class="loader-cell">
                        <div class="loader-data-table">
                          <app-button-loader [borderStyle]="'3px solid var(--brand-primary-color)'"></app-button-loader>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
            
                  <!-- Table Data -->
                  <ng-container *ngIf="!loadingClassTableData && tableBodyData && tableBodyData.length > 0">
                    <ng-container *ngFor="let tableInfo of tableBodyData">
                      <tr>
                        <ng-container *ngFor="let tableColumns of tableHeaderData">
                          <td *ngIf="tableColumns.isDefault === 1">
                            <span>
                              {{ tableInfo[tableColumns.columnName] }}
                            </span>
                          </td>
                        </ng-container>
                      </tr>
                    </ng-container>
                  </ng-container>
            
                  <!-- No Data Available -->
                  <ng-container *ngIf="!loadingClassTableData && tableBodyData.length == 0">
                    <tr>
                      <td [attr.colspan]="getDefaultColumnsCount()" class="no-data-cell">
                        <div class="no-data-available">
                          <img class="no-data-icon" src="../../assets/img/no_data_available.png" alt="" />
                          <div class="no-data-message">
                            <div class="main-heading-no-data">{{'dataNotAvailable' | translate }}</div>
                            <div class="sub-heading-no-data">
                              {{'dataNotAvailableSecond' | translate }}
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>

      <!-- Pagination -->
      <div class="page-switcher-container"
        *ngIf="(overdueFeeData && overdueFeeData.length > 0) || (tableBodyData && tableBodyData.length > 0)">
        <!-- Table View Pagination Dropdown (only for table view) -->
        <div class="select-number-of-page" *ngIf="appliedSections.length === 1">
          <span>{{'showResult' | translate}}</span>
          <select class="page-limit-for-class-data-limit" [(ngModel)]="tableViewPageLimit"
            (change)="onTablePageLimitChange($event)">
            <option value="10">10</option>
            <option value="20">20</option>
          </select>
        </div>

        <!-- Page Number Navigation (for both views) -->
        <div class="page-number-container">
          <div class="icon-for-page-switch" *ngIf="startingPageNumber > 1" (click)="previousPage()">
            <i class="ri-arrow-left-s-line"></i>
          </div>
          <ng-container *ngFor="let item of pageNumbers">
            <div [ngClass]="{
                      'icon-for-page-switch-selected': item == startingPageNumber,
                      'icon-for-page-switch': item != startingPageNumber,
                      'icon-for-page-switch-disabled': item === '...'
            }" (click)="goToPage(item)">
              {{ item }}
            </div>
          </ng-container>
          <div class="icon-for-page-switch" *ngIf="startingPageNumber != maxPageNumber && maxPageNumber > 1"
            (click)="nextPage()">
            <i class="ri-arrow-right-s-line"></i>
          </div>
        </div>
      </div>

      <!-- Export Modal -->

<div class="modal" id="columnSelectionModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-export-report-pop-up" role="document">
    <div class="modal-content export-report-pop-up-main-container">
      <div class="heading-pop-up-heading">
        <div class="export-report-heading">
          <div>{{'exportReport' | translate}}</div>
          <div (click)="closeColumnSelectionModal()" class="close">
            <i class="ri-close-line"></i>
          </div>
        </div>
        <div class="second-message-container">
          {{ 'checkincheckoutExport' | translate }}
        </div>
      </div>

      <div class="body-pop-up-export-report">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <div class="send-report-to-another-mail">
            {{ 'selectColumnsWantExport' | translate}}
          </div>
          <div class="export-select-all-toggle">
            <p-inputSwitch [ngModel]="selectAllExportColumns" (ngModelChange)="toggleSelectAllExportColumns()">
            </p-inputSwitch>
            <label class="export-label">
              {{ 'selectall' | translate }}
            </label>
          </div>
        </div>

        <div style="max-height:250px;overflow-y:auto;margin-bottom:12px;position:relative;">

          <div *ngFor="let column of exportColumns; let i = index" class="export-row"
            [ngClass]="{ 'row-alt': i % 2 === 1 }">
            <p-inputSwitch class="export-switch" [ngModel]="column.isSelected" (ngModelChange)="toggleExportColumn(i)">
            </p-inputSwitch>
            <label style="margin-left: 10px;">
              {{ column.name }}
            </label>
          </div>
        </div>

        <div class="export-button-container">
          <button (click)="closeColumnSelectionModal()" class="cancel-button">
            {{'cancel' | translate}}
          </button>
          <button *ngIf="!isExportingReport" (click)="exportTableViewReport()" class="export-button">
            {{'export' | translate}}
          </button>
          <button *ngIf="isExportingReport" class="export-button">
            <app-button-loader></app-button-loader>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
  </div>
</div>

<div *ngIf="isSortNotAllowedModalOpen" id="sortNotAllowedModal" class="modal" style="display: block;">
  <div class="modal-content">
    <div class="modal-header">
      <h2>{{'sortHeading' | translate}}</h2>
      <span class="close" (click)="closeSortNotAllowedPopUp()">&times;</span>
    </div>
    <div class="modal-body">
      <p>{{'sortErrorMessage' | translate}}:
      </p>

      <!-- Table for Student List -->
      <div class="student-list-container"
        *ngIf="studentsWithNoRollNumberList && studentsWithNoRollNumberList.length > 0">
        <table class="student-list-table">
          <thead>
            <tr>
              <th>{{'studentName' | translate}}</th>
              <th>{{'studentId' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let student of studentsWithNoRollNumberList">
              <td>{{ student.studentName }}</td>
              <td>{{ student.registrationId }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-footer">
      <button (click)="closeSortNotAllowedPopUp()">{{'okay' | translate}}</button>
    </div>
  </div>
</div>